import api from './api';

interface UserProfile {
  user_id: string;
  name: string;
  telegram_id?: string;
  is_admin?: boolean;
  last_selected_restaurant_id?: string;
  created_at: string;
  updated_at?: string;
}

interface AdminCheckResponse {
  telegram_id: string;
  is_admin: boolean;
}

class UserService {
  /**
   * Проверка является ли пользователь администратором
   */
  async checkIsAdmin(telegramId: string): Promise<boolean> {
    try {
      const response = await api.get<AdminCheckResponse>(
        `/users/is-admin?telegram_id=${telegramId}`,
        {},
        false // Не кэшируем проверку админа
      );
      return response.is_admin;
    } catch (error) {
      console.error('Error checking admin status:', error);
      return false;
    }
  }

  /**
   * Получение последнего выбранного ресторана пользователя
   */
  async getLastSelectedRestaurant(telegramId: string): Promise<string | null> {
    try {
      const response = await api.get<{ restaurant_id: string | null }>(
        `/users/restaurant/last?telegram_id=${telegramId}`
      );
      return response.restaurant_id;
    } catch (error) {
      console.error('Error fetching last selected restaurant:', error);
      return null;
    }
  }

  /**
   * Обновление последнего выбранного ресторана пользователя
   */
  async updateLastSelectedRestaurant(telegramId: string, restaurantId: string): Promise<boolean> {
    try {
      await api.post('/users/restaurant/last', {
        telegram_id: telegramId,
        restaurant_id: restaurantId,
      });
      return true;
    } catch (error) {
      console.error('Error updating last selected restaurant:', error);
      return false;
    }
  }

  /**
   * Получение профиля пользователя
   */
  async getUserProfile(telegramId: string): Promise<UserProfile | null> {
    try {
      const response = await api.get<UserProfile>(
        `/users/profile?telegram_id=${telegramId}`
      );
      return response;
    } catch (error) {
      console.error('Error fetching user profile:', error);
      return null;
    }
  }

  /**
   * Создание или обновление профиля пользователя
   */
  async createOrUpdateUserProfile(
    telegramId: string,
    name?: string,
    userId?: string
  ): Promise<UserProfile | null> {
    try {
      const response = await api.post<UserProfile>('/users/profile', {
        telegram_id: telegramId,
        name,
        user_id: userId,
      });
      return response;
    } catch (error) {
      console.error('Error creating/updating user profile:', error);
      return null;
    }
  }
}

export default new UserService();
